import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-integration-review',
  templateUrl: './integration-review.component.html',
  styleUrls: ['./integration-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationReviewComponent {
  @Input() youtubeReviewLink: string = '';
}
